export class Item {
    public id: number;
    public projectId: number;
    public itemNumber: string;
    public isHott: boolean;
    public isPo: boolean;
    public updatedBy: number;
    public updatedDate: Date;
    [key: string]: string | number | Date | boolean;

    constructor(other?: Partial<Item>) {
        this.id = other?.id || 0;
        this.projectId = other?.projectId || 0;
        this.itemNumber = other?.itemNumber || "";
        this.isHott = other?.isHott || false;
        this.isPo = other?.isPo || false;
        this.updatedBy = other?.updatedBy || 0;
        this.updatedDate = other?.updatedDate || new Date();
    }
}